import {isServer} from '@rocket-ui/tools';
import {useEffect, useLayoutEffect} from 'react';

export const useIsoMorphicEffect = isServer ? useEffect : useLayoutEffect;
